/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AggregatedCurveAckDto } from './aggregatedCurveAckDto';

/**
 * Queued ack
 */
export interface QueuedAck {
  done: boolean;
  status: string;
  result: AggregatedCurveAckDto;
}
